import request from '@/router/axios'

//创建题目
export function createSubject (obj) {
  return request({
    url: '/exam/admin/subject',
    method: 'post',
    data: obj,
  })
}

//题目详情
export function getSubjectDetail (id) {
  return request({
    url: `/exam/admin/subject/${id}`,
    method: 'get',
  })
}

export function getSubjectDetailList (ids) {
  return request({
    url: `/exam/admin/subject/${ids}`,
    method: 'get',
  })
}

//题目列表
export function getSubjectList (param) {
  return request({
    url: '/exam/admin/subjects',
    method: 'get',
    params: param,
  })
}

//删除题目
export function deleteSubject (id) {
  return request({
    url: `/exam/admin/subject/${id}`,
    method: 'delete',
  })
}

export function deleteSubjects (ids) {
  return request({
    url: `/exam/admin/subjects/${ids}`,
    method: 'delete',
  })
}

//编辑题目
export function editSubject (obj) {
  return request({
    url: `/exam/admin/subject/${obj.id}`,
    method: 'put',
    data: obj,
  })
}
// 导入题目
export function importSubjectList (data) {
  return request({
    url: '/exam/admin/subject/import',
    method: 'post',
    data
  })
}
// 下载模板
export function downloadSubjectImportTemplate () {
  return request({
    url: '/exam/admin/subject/import-template',
    method: 'get',
  })
}